import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../Context/AppContext';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import SideLeft from '../layout/SideLeft';
import ServerStream from '../components/ServerStream';
import { get } from '../utils/fetcher';
import StorageListItem from '../components/StorageListItem';
import VideoLocationLoad from '../components/VideoLocationLoad';
import { Folder, Server } from 'lucide-react';
import ProcessingVideo from '../components/ProcessingVideo';

const ServerConf = () => {
    const [compCenter, setCompCenter] = useState(<></>)
    const [storage, setStorage] = useState(null)
    const [subServer, setSubServer] = useState(null)
    const { setCurrentPage } = useContext(AppContext)
    const init = async () => {
        const responseUrl = await get('/storage/get');
        setStorage(responseUrl)
    }
    const openPagination = (s) => {
        setCompCenter(<StorageListItem data={s} />)
    }
    useEffect(() => {
        setCurrentPage('server_conf')
        init()
    }, [])
    console.log(subServer);


    return (
        <MainLayout>
            <CenterLayout>
                <nav className="gap1 df">
                    <button onClick={() => {
                        setCompCenter(<VideoLocationLoad />);
                        setSubServer(null)
                    }} className='card carder cw '>VIDEO LOCATION en LOAD</button>
                    {storage?.length > 0 && storage.map((s, i) => (
                        <button onClick={() => setSubServer(s)} className='card carder cw ' key={"storage_server" + i}>{s.name}</button>
                    ))}
                </nav>
                {subServer && (
                    <nav className="gap1 df py1">
                        <button onClick={() => openPagination(subServer)} className='card carder cw df aic ' ><Folder color='#fff' size={15} className='mr1' /> Liste videos</button>
                        <button onClick={() => setCompCenter(<ProcessingVideo serverInfo={subServer} />)} className='card carder cw df aic ' ><Server color='#fff' size={15} className='mr1' /> Processing videos</button>
                    </nav>
                )}
                {compCenter}
            </CenterLayout>
            <SideLeft>
                <ServerStream />
            </SideLeft>
        </MainLayout>
    );
};

export default ServerConf;